import { Link } from 'react-router-dom';

import { useOrganizationId } from '@/hooks/useSwr';

import { usePromptName } from './store/evaluatorStore';

export function EvaluatorHubPromptPlaygroundLink(props: { text?: string }) {
  const organizationId = useOrganizationId();
  const { promptName, commitHash } = usePromptName();

  return (
    <Link
      className="underline"
      target="_blank"
      to={`/prompts/${promptName}/playground?organizationId=${organizationId}&commit=${commitHash}`}
    >
      {props.text ?? 'Playground'}
    </Link>
  );
}
